//@ts-nocheck
import { useState, useContext, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import Modal from "react-modal";
import InputForm from "../../Components/InputForm/InputForm";
import { getLoanRequestData } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../Helpers/Network/APICalls";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import notify from "../../Helpers/ToastNotification";
import ButtonComponent from "../../Components/ButtonForm/Button";
import "./style.css";

Modal.setAppElement("#root"); // Use the selector for your root element

const LoanDashboard = () => {
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const context = getContext();
  let MemberId = context.MemberId;
  const [searchText, setSearchText] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [dashboardData, setDashboardData] = useState([]);

  useEffect(() => {
    getDashboardData("");
  }, [start, sortColumn, sortDirection, searchText, count]);

  const getDashboardData = async (btn: any) => {
    showLoader();
    let obj = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      MemberId: MemberId,
      UnitCodeId: "",
      TypeofApplicantId: "",
      FromDate: "",
      ToDate: "",
      Status: "",
      IsApproval: 0,
      IsAgreement: 0,
      IsFinalDisbursement: 0,
    };

    const resp = await APICall(getLoanRequestData, obj);
debugger;
    if (resp?.Data?.length > 0) {
      setDashboardData(resp?.Data);
    } else {
      setDashboardData([]);
    }

    setCount(resp?.Data[0]?.TotalCount || resp?.Data?.length || 0);
    hideLoader();
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };
  const GridColumns = [
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "LoanRequestId",
      label: "LoanRequestId",
      options: {
        display: false,
      },
    },
    {
      name: "MemberId",
      label: "Member No",
      options: {
        display: false,
      },
    },
    {
      name: "MemberNo",
      label: "Member No",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "Name",
      label: "Full Name",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "LoanTypeName",
      label: "Loan Type",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "AdditionalLoanAmount",
      label: "Additional Loan Amount",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "Status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        display: true,
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let Id = tableMeta.rowData[1];
          return (
            <Tooltip title="edit">
              <p className="ml-3">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/LoanModule", {
                      state: { Id },
                    });
                  }}
                >
                  <i className="fas fa-edit"></i>
                </a>
              </p>
            </Tooltip>
          );
        },
      },
    },
  ];

  return (
    <>
      <div className="form-main">
        <div className="page-title w-100">
          <div className="col-lg-12 p-0">
            <div className="row">
              <div className="col-lg-6 col-md-6"></div>
              <div className="col-lg-4 col-md-4">
                <div className="row d-flex justify-content-end mr-xl-2 mr-md-2">
                  <div className="col-lg-12 searchInput">
                    <InputForm
                      value={searchText}
                      placeholder={"Search"}
                      isDisabled={false}
                      textArea={false}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                    />
                    <i className="fa fa-search ml-2" aria-hidden="true"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-md-2">
                <div
                  className="float-right col-sm-offset-2"
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <ButtonComponent
                    className="btn btn-submit"
                    style={{
                      marginLeft: 5,
                      cursor: "pointer",
                    }}
                    icon={"fas fa-search-dollar"}
                    value={"Apply For Loan"}
                    onClick={() => {
                      navigate("/LoanModule", {
                        state: {
                          Id: 0,
                        },
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <DynamicGrid
          options={Options}
          data={dashboardData}
          columns={GridColumns}
        />
      </div>
    </>
  );
};

export default LoanDashboard;
